import React from "react";
import { ArrowLeft, AlertCircle } from "lucide-react";
import useNewActivity from "./hooks/useNewActivity";

import BasicInformation from "./components/BasicInformation";
import LocationTime from "./components/LocationTime";
import Details from "./components/Details";
import AccordionSection from "./components/AccordionSection";

const NewActivity = () => {
  const {
    formData,
    activeSection,
    completedSections,
    isLoading,
    error,
    user,
    handleSubmit,
    handleInputChange,
    handleMaxAttendeesChange,
    handleSectionToggle,
    navigate
  } = useNewActivity();

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500" />
      </div>
    );
  }

  const onSubmit = (e) => {
    e.preventDefault(); // Prevenir el envío automático
    handleSubmit(e);
  };

  return (
    <div className="min-h-screen bg-gray-50 mt-14">
      {/* Header */}
      <div className="bg-white shadow-sm sticky top-14 left-0 right-0 z-40">
        <div className="flex items-center justify-between py-2 px-3">
          <button 
            type="button" // Añadido type="button" para prevenir submit
            onClick={() => navigate(-1)}
            className="p-1.5 hover:bg-gray-100 rounded-full transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
          <h1 className="text-base font-medium">Create Activity</h1>
          <div className="w-8" />
        </div>
      </div>

      {/* Main Content */}
      <div className="pb-32">
        {/* Error Message */}
        {error && (
          <div className="mx-4 mt-3 p-2.5 bg-red-50 border border-red-200 rounded-xl flex items-center gap-2 text-red-600">
            <AlertCircle className="w-4 h-4" />
            <span className="text-sm">{error}</span>
          </div>
        )}

        {/* Form wrapping everything including the submit button */}
        <form className="mt-4" onSubmit={onSubmit}>
          <div className="space-y-4">
            <AccordionSection
              title="Basic Information"
              isOpen={activeSection === 'basic'}
              isComplete={completedSections.basic}
              onToggle={() => handleSectionToggle('basic')}
            >
              <BasicInformation
                formData={formData}
                handleInputChange={handleInputChange}
                handleMaxAttendeesChange={handleMaxAttendeesChange}
              />
            </AccordionSection>

            <AccordionSection
              title="Location & Time"
              isOpen={activeSection === 'locationTime'}
              isComplete={completedSections.locationTime}
              onToggle={() => handleSectionToggle('locationTime')}
            >
              <LocationTime
                formData={formData}
                handleInputChange={handleInputChange}
              />
            </AccordionSection>

            <AccordionSection
              title="Details"
              isOpen={activeSection === 'details'}
              isComplete={completedSections.details}
              onToggle={() => handleSectionToggle('details')}
            >
              <Details
                formData={formData}
                handleInputChange={handleInputChange}
              />
            </AccordionSection>
          </div>

          {/* Fixed Bottom Button - Ahora dentro del form */}
          <div className="fixed bottom-16 left-0 right-0 p-4 bg-white border-t border-gray-100 z-40">
            <button
              type="submit"
              disabled={isLoading || !completedSections.basic || !completedSections.locationTime}
              className="w-full bg-orange-500 text-white py-3 rounded-xl font-medium hover:bg-orange-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              {isLoading ? "Creating..." : "Create Activity"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewActivity;